import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { authAPI } from '@/api/new-api'

interface GetPackageSignatureRequest {
  packageId: number
}

export const getPackageSignatureQueryKey = (data: GetPackageSignatureRequest) => [
  'package-signature',
  data,
]

export const getPackageSignature = async (
  data: GetPackageSignatureRequest,
): Promise<Blob | null> => {
  const response = await authAPI.get(`/packages/${data.packageId}/signature`, {
    responseType: 'blob',
  })

  // API may return empty blob
  if (!response?.data || response?.headers['content-type'] !== 'image/png') {
    return null
  }

  return response.data
}

export const useGetPackageSignature = (data: GetPackageSignatureRequest) => {
  const queryResult = useQuery({
    enabled: data.packageId > 0,
    queryFn: () => getPackageSignature(data),
    queryKey: getPackageSignatureQueryKey(data),
    select: (blob) => (blob ? URL.createObjectURL(blob) : null),
  })

  useEffect(() => {
    return () => {
      if (queryResult.data) {
        URL.revokeObjectURL(queryResult.data)
      }
    }
  }, [queryResult.data])

  return queryResult
}
